import React from "react";
import { Navigate } from "react-router-dom";
import { hasMinimumRole } from "../../layouts/roleUtils";
import { ROLES } from "../../layouts/roles";

const ProtectedRoute = ({ children, requiredRole, currentUser }) => {
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!hasMinimumRole(currentUser.role, requiredRole)) {
    return (
      <div style={{ padding: "1rem", color: "red" }}>
        You do not have permission to view this page.
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
